import { Component, input } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { CreditCardItem } from './po-line-item.model'
import { PoCommonFieldsComponent } from './po-common-fields.component'

@Component({
    selector: 'app-credit-card-form',
    templateUrl: './credit-card-form.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule, PoCommonFieldsComponent],
})
export class CreditCardFormComponent {
    item = input.required<CreditCardItem>()

    expenseCategoryOptions = ['', 'Travel', 'Fuel', 'Small tools / supplies', 'Subscriptions / software', 'Meals', 'Other']
}
